import { StatsigSynchronousProvider } from '@eventbrite/statsig';
import { ComponentProps } from 'react';
import { connect } from 'react-redux';
import { getStatsigConfigFromState } from '../../selectors/statsig';
import { CheckoutState } from '../../state';

const mapStateToProps = (
    state: CheckoutState,
): Pick<ComponentProps<typeof StatsigSynchronousProvider>, 'user'> => ({
    user: getStatsigConfigFromState(state),
});

export type ConnectedProps = Pick<
    ComponentProps<typeof StatsigSynchronousProvider>,
    keyof ReturnType<typeof mapStateToProps>
>;

export const connectStatsigProvider = connect(mapStateToProps);
